import Axios from 'axios'
import { TFunction } from 'i18next'
import _ from 'lodash'
import { TelemetryService } from 'services/Telemetry'
import { ErrorMessage } from 'store/Application/appActions'

const APP_BUILD_NUMBER_STORAGE_KEY = 'appBuildNumber'

async function getCDNCurrentVersion() {
  const url = `version.json?c=${Date.now()}`
  const headers = {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
  }

  try {
    const response = await Axios.get<{ appBuildNumber: string }>(url, {
      headers,
    })

    return response.data.appBuildNumber
  } catch (err) {
    console.error(JSON.stringify(err))

    if (err['code'] === 'ECONNABORTED') {
      return undefined
    }

    ErrorMessage(
      'Quotation Factory',
      'error loading CDN Version Number: ' + err.toString()
    )
    return undefined
  }
}

function saveVersionAsLocalVersion(cdnVersion: string) {
  if (!cdnVersion) {
    localStorage.removeItem(APP_BUILD_NUMBER_STORAGE_KEY)
  } else {
    localStorage.setItem(APP_BUILD_NUMBER_STORAGE_KEY, cdnVersion)
  }
}

const checkAppVersionSkipRoutes = ['login', 'logout', 'accept', 'auth']

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const checkAppVersion = async (t: TFunction) => {
  // alert('checkAppVersion')
  try {
    const pathname = window.location.pathname.toLowerCase()

    if (checkAppVersionSkipRoutes.some((route) => pathname.includes(route))) {
      console.info('checkAppVersion: skipping route', pathname)
      return
    }

    if (window.location.pathname.toLowerCase().includes('accept')) {
      console.info('checkAppVersion: accept page, skip version check')
      return
    }

    const localCurrentVersion = localStorage.getItem(
      APP_BUILD_NUMBER_STORAGE_KEY
    )
    const cdnCurrentVersion = await getCDNCurrentVersion()

    console.info('rh24 cdnCurrentVersion', cdnCurrentVersion)
    console.info('rh24 currentVersion', localCurrentVersion)

    if (!cdnCurrentVersion) {
      //cdn current version not available, let just load the app normally (but maybe with Browser caching problems)
      return
    }

    if (!localCurrentVersion) {
      saveVersionAsLocalVersion(cdnCurrentVersion)
      return
    }

    if (cdnCurrentVersion === localCurrentVersion) {
      console.info('rh24 app is up to date')
      return
    }

    saveVersionAsLocalVersion('WAITING_UPDATE')

    window.addEventListener('beforeunload', function () {
      saveVersionAsLocalVersion(undefined)
    })

    console.warn(
      `[Quotation Factory]: Needs to be updated, reloading the window (currentVersion: ${localCurrentVersion} | vnext: ${cdnCurrentVersion})`,
      cdnCurrentVersion
    )

    //eslint-disable-next-line
    clearTheCache()

    // window.location = window.location
    // window.location.href = window.location.href

    console.error('will use window.location.replace')
    // window.location.replace(window.location.href)
  } catch (err) {
    TelemetryService.getInstance().logError(err as Error)
    console.error(err)
    ErrorMessage(
      'Quotation Factory',
      'error updating the app: ' + err.toString()
    )
  }
}

const clearTheCache = async () => {
  try {
    if ('caches' in window) {
      // Service worker cache should be cleared with caches.delete()
      const cacheKeys = await window.caches.keys()
      await Promise.all(
        cacheKeys.map((key) => {
          window.caches.delete(key)
        })
      )
    }
  } catch (err) {
    console.error('rh24 error when cleaning browser cache', err)
  }
}

export const checkAppVersionThrottled = (t: TFunction) =>
  _.throttle(() => checkAppVersion(t), 60000, {
    leading: true,
    trailing: false,
  })
